import { useState } from 'react';

/**
 * 전역 AlertDialog 상태 관리 훅
 * JavaScript alert()를 대체하는 MUI AlertDialog 시스템
 */
export const useGlobalAlert = () => {
  const [alertDialog, setAlertDialog] = useState({
    open: false,
    type: 'info', // 'success', 'error', 'warning', 'info'
    title: '',
    message: '',
    confirmText: '확인'
  });

  /**
   * AlertDialog 표시 함수
   * @param {string} type - 알림 타입 ('success', 'error', 'warning', 'info')
   * @param {string} title - 제목
   * @param {string} message - 메시지 내용
   * @param {string} confirmText - 확인 버튼 텍스트 (기본: '확인')
   */
  const showAlert = (type, title, message, confirmText = '확인') => {
    setAlertDialog({
      open: true,
      type,
      title,
      message,
      confirmText
    });
  };

  /**
   * AlertDialog 닫기 함수
   */
  const closeAlert = () => {
    setAlertDialog({
      open: false,
      type: 'info',
      title: '',
      message: '',
      confirmText: '확인'
    });
  };

  return {
    alertDialog,
    showAlert,
    closeAlert
  };
}; 